import { Config } from '@/pages/front/pages/examCenter/pages/reportSetting/components/Parameters';
import { TemplateConfig } from '@/pages/front/pages/template/const';
import service from '..';

export const getRateConfig = (examid: ID) =>
  service.get<Config>(`/teacher/mana/exam/${examid}/analysis/rateconfig`);

// 根据百分比计算分数
export const calcScoreByPercent = (params: CalcScoreByPercentParams) =>
  service.get<number>(`/edu/mana/exam/${params.examid}/analysis/rateconfig/calscore/byrate`, params);

// 根据分数计算百分比
export const calcPercentByScore = (params: CalcPercentByScoreParams) =>
  service.get<number>(`/edu/mana/exam/${params.examid}/analysis/rateconfig/calrate/byscore`, params);

// 多个分数计算四率
export const mutilCalcPercentByScore = (params: CalcGradePercentByScoreParams) =>
  service.get(`/edu/mana/exam/${params.examid}/analysis/rateconfig/calrate/byscores`, params);

// 根据普高率计算普高线
export const calcGradeScoreByPercent = (params: CalcGradeLineByPercentParams) =>
  service.get<number>(`/edu/mana/exam/${params.examid}/analysis/rateconfig/calseniorscoreline/byrate`, params);

// 根据普高线计算普高率
export const calcGradePercentByScore = (params: CalcGradePercentByScoreParams) =>
  service.get<number>(`/edu/mana/exam/${params.examid}/analysis/rateconfig/calrate/byseniorscoreline`, params);

// 保存报告指标设置
export const saveSetting = (examid: ID, params: Config) =>
  service.putJSON(`/edu/mana/exam/${examid}/analysis/rateconfig`, params);

// 获取计分方式
export const getAbsent = (examid: ID) =>
  service.get<TemplateConfig['scoreConfig']>(`/teacher/mana/exam/${examid}/analysis/scoreconfig`);

// 保存计分方式
export const saveAbsent = (examid: ID, params:TemplateConfig['scoreConfig'] ) =>
  service.putJSON(`/edu/mana/exam/${examid}/analysis/scoreconfig`, params);

// 批量根据分数线计算四率
export const apiCalcMutilPercentByScore = (params: ApiCalcMutilPercentByScoreParams) =>
  service.postJSON<CalcMutilPercentByScoreProps[]>(`/edu/mana/exam/${params.examid}/analysis/rateconfig/calrate/byglescores`, params);

// 批量根据参考四率计算分数线
export const apiCalcMutilScoreByRate = (params: ApiCalcMutilScoreByRateParams) =>
  service.postJSON<CalcMutilPercentByScoreProps[]>(`/edu/mana/exam/${params.examid}/analysis/rateconfig/calscore/byrates`, params);

// 报告设置-获取小学等第配置
export const getPrimaryLevel = (examid: ID) =>
  service.get<TemplateConfig['primaryLevelConfig']>(`/teacher/mana/exam/${examid}/analysis/primarylevelconfig`);

// 报告设置-小学等第-保存
export const savePrimaryLevel = (examid: ID, params:TemplateConfig['primaryLevelConfig'] ) =>
  service.putJSON(`/edu/mana/exam/${examid}/analysis/primarylevelconfig`, params);
